module.exports = __webpack_public_path__ + "img/beer.991e0587.png";